import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { FetchStatus } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import {
  NpAvailableTimesResponse,
  NpScheduleSessionsResponse,
} from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import {
  CLEAR_NP_AVAILABLE_TIMES,
  CLEAR_NP_SCHEDULED_SESSIONS,
  GET_NP_AVAILABLE_TIMES_FULFILLED,
  GET_NP_AVAILABLE_TIMES_PENDING,
  GET_NP_AVAILABLE_TIMES_REJECTED,
  SCHEDULE_NP_SESSIONS_FULFILLED,
  SCHEDULE_NP_SESSIONS_PENDING,
  SCHEDULE_NP_SESSIONS_REJECTED,
} from './npTestingActions'

const initialState = fromJS({
  availableTimes: null,
  availableTimesLoadingStatus: null,
  // Response of the last schedule-sessions request; holds the episodeId later bookings in the same flow need
  scheduledSessions: null,
  scheduleSessionsLoadingStatus: null,
})

export default createReducer(initialState, {
  [GET_NP_AVAILABLE_TIMES_PENDING]: ($$state: Map<string, any>) => {
    return $$state.set('availableTimesLoadingStatus', FetchStatus.PENDING)
  },
  [GET_NP_AVAILABLE_TIMES_FULFILLED]: ($$state: Map<string, any>, action: { payload: NpAvailableTimesResponse }) => {
    return $$state.set('availableTimes', fromJS(action.payload)).set('availableTimesLoadingStatus', FetchStatus.SUCCESS)
  },
  [GET_NP_AVAILABLE_TIMES_REJECTED]: ($$state: Map<string, any>, action: { meta?: { aborted?: boolean } }) => {
    // An aborted request (e.g. the page unmounted) is not an error
    if (action.meta?.aborted) {
      return $$state
    }
    return $$state.set('availableTimesLoadingStatus', FetchStatus.ERROR)
  },
  [CLEAR_NP_AVAILABLE_TIMES]: ($$state: Map<string, any>) => {
    // Only the availability is cleared; a booking made earlier in the flow must survive leaving the calendar
    return $$state.set('availableTimes', null).set('availableTimesLoadingStatus', null)
  },
  [SCHEDULE_NP_SESSIONS_PENDING]: ($$state: Map<string, any>) => {
    return $$state.set('scheduleSessionsLoadingStatus', FetchStatus.PENDING)
  },
  [SCHEDULE_NP_SESSIONS_FULFILLED]: ($$state: Map<string, any>, action: { payload: NpScheduleSessionsResponse }) => {
    return $$state
      .set('scheduledSessions', fromJS(action.payload))
      .set('scheduleSessionsLoadingStatus', FetchStatus.SUCCESS)
  },
  [SCHEDULE_NP_SESSIONS_REJECTED]: ($$state: Map<string, any>) => {
    return $$state.set('scheduleSessionsLoadingStatus', FetchStatus.ERROR)
  },
  [CLEAR_NP_SCHEDULED_SESSIONS]: ($$state: Map<string, any>) => {
    return $$state.set('scheduledSessions', null).set('scheduleSessionsLoadingStatus', null)
  },
})
